import { render } from "./DetalleVentas.vue?vue&type=template&id=f3453f50"
import script from "./DetalleVentas.vue?vue&type=script&lang=js"
export * from "./DetalleVentas.vue?vue&type=script&lang=js"

import "./DetalleVentas.vue?vue&type=style&index=0&id=f3453f50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__